import React from 'react'
import MaterialSymbol from '../material-symbol'

const ExpandLess = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="expand_less" {...props} />
))

ExpandLess.displayName = 'ExpandLess'

export default ExpandLess
